const PHONE_LENGTH_RULES = {
  IN: { min: 10, max: 10, message: 'Enter a valid 10-digit Indian mobile number.' },
  US: { min: 10, max: 10, message: 'Enter a valid 10-digit US phone number.' },
  CA: { min: 10, max: 10, message: 'Enter a valid 10-digit Canadian phone number.' },
  GB: { min: 9, max: 10, message: 'Enter a valid UK phone number.' },
  AU: { min: 9, max: 9, message: 'Enter a valid 9-digit Australian phone number.' },
  NZ: { min: 8, max: 10, message: 'Enter a valid New Zealand phone number.' },
  SG: { min: 8, max: 8, message: 'Enter a valid 8-digit Singapore phone number.' },
  AE: { min: 9, max: 9, message: 'Enter a valid 9-digit UAE phone number.' },
  DE: { min: 10, max: 11, message: 'Enter a valid German phone number.' },
  FR: { min: 9, max: 9, message: 'Enter a valid 9-digit French phone number.' },
  ES: { min: 9, max: 9, message: 'Enter a valid 9-digit Spanish phone number.' },
  IT: { min: 9, max: 10, message: 'Enter a valid Italian phone number.' },
  BR: { min: 10, max: 11, message: 'Enter a valid Brazilian phone number.' },
  JP: { min: 9, max: 10, message: 'Enter a valid Japanese phone number.' },
};

const DEFAULT_PHONE_RULE = {
  min: 6,
  max: 12,
  message: 'Enter a valid phone number for the selected country.',
};

const COUNTRY_DIAL_CODE_FALLBACK = {
  US: '1',
  CA: '1',
  IN: '91',
  GB: '44',
  AE: '971',
  DE: '49',
  FR: '33',
  ES: '34',
  IT: '39',
  BR: '55',
  AU: '61',
  NZ: '64',
  SG: '65',
  JP: '81',
};

const normalizeCountryCode = (countryCode = '') => String(countryCode || '').trim().toUpperCase();

const getPhoneRule = (countryCode = '') => PHONE_LENGTH_RULES[normalizeCountryCode(countryCode)] || DEFAULT_PHONE_RULE;

const getCountryDialCode = (countryCode = '', countries = []) => {
  const normalizedCountry = normalizeCountryCode(countryCode);
  if (!normalizedCountry) return '';
  const match = Array.isArray(countries)
    ? countries.find((country) => normalizeCountryCode(country?.isoCode) === normalizedCountry)
    : null;
  if (match?.phonecode) {
    return String(match.phonecode).replace(/\D/g, '');
  }
  return COUNTRY_DIAL_CODE_FALLBACK[normalizedCountry] || '';
};

const normalizeCandidateList = (value = '', countryCode = '', countries = []) => {
  const digits = String(value || '').replace(/\D/g, '');
  const dialCode = getCountryDialCode(countryCode, countries);
  const candidates = [];

  const addCandidate = (candidate) => {
    const normalized = String(candidate || '').replace(/\D/g, '');
    if (normalized && !candidates.includes(normalized)) {
      candidates.push(normalized);
    }
  };

  addCandidate(digits);
  if (digits.startsWith('00')) {
    addCandidate(digits.slice(2));
  }

  for (const candidate of [...candidates]) {
    if (dialCode && candidate.startsWith(dialCode) && candidate.length > dialCode.length) {
      addCandidate(candidate.slice(dialCode.length));
    }
    if (candidate.startsWith('0')) {
      addCandidate(candidate.replace(/^0+/, ''));
    }
  }

  return candidates;
};

export const normalizePhoneForCountry = (value = '', countryCode = '', countries = []) => {
  const rule = getPhoneRule(countryCode);
  const candidates = normalizeCandidateList(value, countryCode, countries);
  return candidates.find((candidate) => candidate.length >= rule.min && candidate.length <= rule.max) || '';
};

export const validatePhoneForCountry = (value = '', countryCode = '', countries = []) => {
  const rule = getPhoneRule(countryCode);
  const normalized = normalizePhoneForCountry(value, countryCode, countries);
  return {
    isValid: Boolean(normalized),
    normalized,
    message: normalized ? '' : rule.message,
  };
};

export const getPhoneRequirementMessage = (countryCode = '') => getPhoneRule(countryCode).message;
